import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { WawiApiAddressCreateDialogComponent } from "./create/address-create-dialog.component";
import { WawiApiAddressCreateFormComponent } from "./create/address-create-form.component";
import { WawiApiAddressUpdateDialogComponent } from "./update/address-update-dialog.component";
import { WawiApiAddressUpdateFormComponent } from "./update/address-update-form.component";

@NgModule({
  imports: [CommonComponentsModule],
  declarations: [
    WawiApiAddressCreateFormComponent,
    WawiApiAddressCreateDialogComponent,
    WawiApiAddressUpdateFormComponent,
    WawiApiAddressUpdateDialogComponent,
  ],
  exports: [
    WawiApiAddressCreateFormComponent,
    WawiApiAddressCreateDialogComponent,
    WawiApiAddressUpdateFormComponent,
    WawiApiAddressUpdateDialogComponent,
  ],
})
export class WawiApiAddressesModule {}
